import { captureError } from '@/helpers/RUMService/RUMService';
import { ImmocheckValuationRequestPayload } from '@/types';
import axios from 'axios';

export const apiClient = axios.create({
  baseURL: import.meta.env.VUE_APP_BASE_API_URL,
});

export const prefetchListingToSftiMapping = async (
  listingId: string,
  passThroughHeaders?: Record<string, string>,
) => {
  try {
    const apiUrl = `/immocheck/prefetch?listingId=${listingId}`;
    const requestHeaders = await prepareRequestHeaders(passThroughHeaders);
    const response = await apiClient.get<any>(apiUrl, {
      headers: requestHeaders,
    });
    return response.data;
  } catch (e) {
    captureError(e);
    // When BE returns validation error, normal flow should handle null and show error page
    return null;
  }
};

export const submitImmocheckFormData = async (
  payload: ImmocheckValuationRequestPayload,
): Promise<{ id: string } | null> => {
  try {
    const apiUrl = `/immocheck/submit`;
    const requestHeaders = await prepareRequestHeaders();
    const response = await apiClient.post<any>(apiUrl, payload, { headers: requestHeaders });
    return response.data;
  } catch (error) {
    captureError(error);
    throw error;
  }
};

enum PropertyBrand {
  HOMEGATE = 'homegate',
  IMMOSCOUT24 = 'immoscout24',
}
/**
 * Prepares and returns request headers for UBS Proxy API calls
 */
async function prepareRequestHeaders(
  passThroughHeaders?: Record<string, string>,
): Promise<Record<string, string>> {
  const SMG_PLATFORM_HEADER = 'X-Smg-Platform';
  const headers = passThroughHeaders ?? {};
  headers[SMG_PLATFORM_HEADER] =
    import.meta.env.VUE_APP_PLATFORM === 'hg' ? PropertyBrand.HOMEGATE : PropertyBrand.IMMOSCOUT24;

  return headers;
}
